import styled from 'styled-components';

export const ToggleWithBadgeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  > .badge {
    margin-right: 10px;
    margin-bottom: 10px;
  }
`;
